import React from 'react';
import { c as classnames } from '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';

const IconButton = ({ testId = '', children, title, btnClassName = '', iconClassName = '', ...props }) => (React.createElement("button", { ...props, title: title, "aria-label": title, type: "button", "data-testid": testId !== null && testId !== void 0 ? testId : btnClassName, className: classnames('base-icon-btn', btnClassName) },
    React.createElement("i", { className: iconClassName })));

export { IconButton as default };
//# sourceMappingURL=index.js.map
